import { z } from 'zod'

import { Appraiser } from 'src/shared/components/icons/professions/appraiser'
import { Attorney } from 'src/shared/components/icons/professions/attorney'
import { Contractor } from 'src/shared/components/icons/professions/contractor'
import { Inspector } from 'src/shared/components/icons/professions/inspector'
import { InsuranceBroker } from 'src/shared/components/icons/professions/insurance-broker'
import { LoanOfficer } from 'src/shared/components/icons/professions/loan-officer'
import { RealEstateAgent } from 'src/shared/components/icons/professions/real-estate-agent'
import { TitleRep } from 'src/shared/components/icons/professions/title-rep'
import type { MapItem } from 'src/shared/schemas/utils'

export type Profession =
  | 'real_estate_agent'
  | 'mortgage_loan_officer'
  | 'real_estate_insurance_broker'
  | 'contractor'
  | 'real_estate_attorney'
  | 'property_inspector'
  | 'real_estate_appraiser'
  | 'title_company_rep'

export const ALL_PROFESSIONS: Profession[] = [
  'real_estate_agent',
  'mortgage_loan_officer',
  'real_estate_insurance_broker',
  'contractor',
  'real_estate_attorney',
  'property_inspector',
  'real_estate_appraiser',
  'title_company_rep',
]

export const professionMap: Record<Profession, MapItem> = {
  real_estate_agent: {
    label: 'Real Estate Agent',
    lowerCaseLabel: 'real estate agent',
    subtitle: 'Buy, sell or lease',
    icon: RealEstateAgent,
  },
  mortgage_loan_officer: {
    label: 'Mortgage Loan Officer',
    lowerCaseLabel: 'mortgage loan officer',
    subtitle: 'Purchase or refinance',
    icon: LoanOfficer,
  },
  real_estate_insurance_broker: {
    label: 'Insurance Broker',
    lowerCaseLabel: 'insurance broker',
    icon: InsuranceBroker,
  },
  contractor: {
    label: 'Contractor',
    lowerCaseLabel: 'contractor',
    icon: Contractor,
  },
  real_estate_attorney: {
    label: 'RE Attorney',
    lowerCaseLabel: 'RE attorney',
    icon: Attorney,
  },
  property_inspector: {
    label: 'Property Inspector',
    lowerCaseLabel: 'property inspector',
    icon: Inspector,
  },
  real_estate_appraiser: {
    label: 'RE Appraiser',
    lowerCaseLabel: 'RE appraiser',
    icon: Appraiser,
  },
  title_company_rep: {
    label: 'Title Company Rep',
    lowerCaseLabel: 'title company rep',
    icon: TitleRep,
  },
}

export const professionSchema = z.enum(Object.keys(professionMap) as [Profession, ...Profession[]])
